import moment from 'moment-timezone';

moment.tz.setDefault('utc');

export function handleGraphQLErrors(error, state) {
  if (!error) return state;

  // e.graphQLErrors, Object.keys(e.networkError);
  const errs = {};
  const { graphQLErrors, networkError } = error;
  if (graphQLErrors && graphQLErrors.length > 0) {
    graphQLErrors.reduce((acc, err) => Object.assign(
      acc,
      {
        __default__: `${acc.__default__ ? `${acc.__default__}\n` : ''}${err.message}`,
      }
    ), errs);
  } else if (networkError) {
    Object.assign(errs, {
      __default__: 'Network error',
    });
  }
  return {
    ...state,
    errors: errs,
  };
}

export function queryErrorsToArray(error) {
  if (!error) return [];

  const errs = [];
  const { graphQLErrors, networkError } = error;
  if (graphQLErrors && graphQLErrors.length > 0) {
    graphQLErrors.forEach(err => errs.push(err.message));
  } else if (networkError) {
    errs.push('Network error');
  }

  return errs;
}

export const connectionToData = (connection) => {
  if (!connection) {
    return {
      entities: [],
      pageInfo: {},
    };
  }
  const entities = connection.edges.map((edge) => {
    const item = {
      ...edge.node,
    };
    if (edge.cursor) {
      item.cursor = edge.cursor;
    }
    return item;
  });
  return { entities, pageInfo: connection.pageInfo };
};

export const getCustomConfig = () => {
  const appId = localStorage.getItem('appId') || '';
  const graphqlUri = localStorage.getItem('graphqlUri') || '';
  return { appId, graphqlUri };
};

export const setCustomConfig = (config) => {
  const { appId, graphqlUri } = config;
  localStorage.setItem('appId', appId);
  localStorage.setItem('graphqlUri', graphqlUri);
};

export const resetCustomConfig = () => {
  localStorage.removeItem('appId');
  localStorage.removeItem('graphqlUri');
};

export const useConfig = (defaultConfig, customConfig) => {
  if (customConfig.appId && customConfig.graphqlUri) {
    return customConfig;
  }
  return defaultConfig;
};

export const getLocationSearch = (key) => {
  const { search } = window.location;
  const string = search === '' ? '?' : search;
  const query = new URLSearchParams(string); // eslint-disable-line
  return query.get(key);
};


export const createMarkup = text => ({ __html: text });

export const toDate = (date, format) => moment(date).format(format || 'MMM DD YYYY HH:mm');


export const iFrameDetect = () => window.location !== window.parent.location;

export const anchorTargetForIframe = iFrameDetect() ? '_blank' : '_self';

export const SplitTime = (ms) => {
  const d = moment.duration(ms);
  const Days = () => {
    let result = '';
    const days = d.days();
    if (days > 0) {
      result = `${days}d `;
    }

    return result;
  };

  const Hours = d.hours();
  const Minutes = d.minutes();

  return `${Days()}${Hours}h ${Minutes}m`;
};

export const SplitTimeToSeconds = (ms) => {
  const d = moment.duration(ms / 1000000);
  const Hours = d.hours();
  const Minutes = d.minutes();
  const Seconds = d.seconds();

  return `${Hours}h ${Minutes}m ${Seconds}s`;
};
